// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errorWrapper":"_3Myw-l","messageBoxWrapper":"a4HlRj","prognosisInitial":"aOhdq9","spinnerWrapper":"_1F5mM6","markdown":"_2RaC0C"};